import { useAppSelector } from "store/hooks";
import * as S from "./index.styles"
import { selectUserId } from "store/user/user.selectors";
import { CampaignInfo, ProcessedCampaignInfo } from "types";
import { getDaysLeft } from "store/projects/projectDetails/projectDetails.helpers";

function formatDollarAmount(amount: number): string {
  return "$" + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export interface FundraisingCardProps {
  campaign:ProcessedCampaignInfo
  onClick: () => void;
  onStatsClick: () => void;
}

export default function FundraisingCard({campaign, onClick, onStatsClick}: FundraisingCardProps) {
  const user_id = useAppSelector(selectUserId)
  const campaign_user_id = campaign.user_id
  const my_campaign = user_id === campaign_user_id
  return (
    <S.FundraisingCardContainer>
    <S.Card onClick={onClick} >
      <S.CardTitle>
        {campaign.name}
        {my_campaign &&(<S.CardIcon onClick={(e) => { e.stopPropagation(); onStatsClick(); }} />)}{" "}
      </S.CardTitle>
      <S.CardSubSection>
        <S.CardTag>Goal</S.CardTag>
        <S.CardNumber>{formatDollarAmount(campaign.currentAmounts)}</S.CardNumber>
        <S.CardSubTag>
          pledged of {formatDollarAmount(campaign.totalAmounts)} goal
        </S.CardSubTag>
        <S.ProgressBar
          variant="determinate"
          value={(100 * campaign.currentAmounts) / campaign.totalAmounts}
          style={{ marginTop: "0.5rem" }}
        />
      </S.CardSubSection>
      <S.CardSection>
        <S.CardSubSection>
          <S.CardTag>Total Donors</S.CardTag>
          <S.CardNumber>{campaign.totalDonors}</S.CardNumber>
          <S.CardSubTag>donors in total</S.CardSubTag>
        </S.CardSubSection>
        <S.CardSubSection>
          <S.CardTag>Days Left</S.CardTag>
          <S.CardNumber>{campaign.daysLeft <= 0 ? 0 : campaign.daysLeft}</S.CardNumber>
          <S.CardSubTag>days remaining</S.CardSubTag>
        </S.CardSubSection>
      </S.CardSection>
    </S.Card>


    </S.FundraisingCardContainer>
  
  );
}
